import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Livestream.module.scss';
import { redirectToLogin } from '../../utils/authUtils';
import { AdminStream } from './AdminStream';
import Loader from '../shared/Loader';
import { useAuth } from '../../contexts/AuthContext';

type AppState = 'loading' | 'admin' | 'error';

export const StreamApp: React.FC = () => {
    const { t } = useTranslation();
    const [appState, setAppState] = useState<AppState>('loading');
    const [, setError] = useState<string>('');
    const { admin } = useAuth();

    // Проверка аутентификации при загрузке
    useEffect(() => {
        const token = localStorage.getItem('jwt_token');

        if (token) {
            setAppState('admin');
        } else {
            setError('Authentication required');
            setAppState('error');
        }
    }, []);

    // Админка только для админов - убираем логику для зрителей

    // Повторная попытка аутентификации
    const handleRetry = () => {
        setAppState('loading');
        setError('');
        window.location.reload();
    };

    // Экран загрузки
    if (appState === 'loading') {
        return (
            <div className={styles.centeredPage}>
                <Loader />
                <div style={{ marginTop: 16, fontSize: '18px' }}>{t('livestream.auth.checkingAccess')}...</div>
            </div>
        );
    }

    // Экран ошибки
    if (appState === 'error') {
        return (
            <div className={styles.centeredPage}>
                <div className={styles.paper} style={{ textAlign: 'center', maxWidth: 400 }}>
                    <div style={{ fontSize: '48px', marginBottom: 16 }}>🚫</div>
                    <h2 style={{ color: '#d32f2f', marginBottom: 16 }}>{t('livestream.auth.accessError')}</h2>
                    <p style={{ color: '#666', marginBottom: 24 }}>
                        {t('livestream.auth.loginPrompt')}
                    </p>

                    <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                        <button
                            onClick={() => redirectToLogin()}
                            className={styles.startButton}
                        >
                            {t('livestream.auth.login')}
                        </button>

                        <button
                            onClick={handleRetry}
                            className={styles.saveButton}
                        >
                            {t('livestream.auth.retry')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // === ТОЛЬКО АДМИНЫ ===
    if (!admin) {
        return (
            <div className={styles.centeredPage}>
                <div className={styles.paper} style={{ textAlign: 'center', maxWidth: 400 }}>
                    <div style={{ fontSize: '48px', marginBottom: 16 }}>🚫</div>
                    <h2 style={{ color: '#d32f2f', marginBottom: 16 }}>{t('livestream.auth.accessError')}</h2>
                    <p style={{ color: '#666', marginBottom: 24 }}>
                        {t('livestream.auth.adminOnly')}
                    </p>
                    <button
                        onClick={() => redirectToLogin()}
                        className={styles.startButton}
                    >
                        {t('livestream.auth.login')}
                    </button>
                </div>
            </div>
        );
    }

    // === АДМИН ===
    if (appState === 'admin') {
        return (
            <AdminStream
                userName={admin?.name}
            />
        );
    }

    // Fallback
    return (
        <div className={styles.centeredPage}>
            <div>{t('livestream.auth.unknownError')}</div>
            <button onClick={handleRetry} className={styles.startButton} style={{ marginTop: 16 }}>
                {t('livestream.auth.reload')}
            </button>
        </div>
    );
}; 